const defaultBuiltinAdminId = '0015849442017540000000155d4c6010'
const defaultSuperAdminId = '27e55a01b74342189b000000000admin'
const defaultRoleId = '27e55a01b74342189b00000adminrole'
const defaultSkillGroupId = '0015870307129860015100155d4c6010'
const defaultUserGroupId = '0015868314746520008200155d4c6010'
const defaultAcdId = '061505e3d58000159671DEFALUTACD00'

export default {
  defaultBuiltinAdminId,
  defaultSuperAdminId,
  defaultRoleId,
  defaultSkillGroupId,
  defaultUserGroupId,
  defaultAcdId
}
